module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-miterlimit=\"10\"><path d=\"M17 14H8\" stroke-linecap=\"square\"></path><path d=\"M14 18.9l5-4.9-5-4.9\"></path><circle cx=\"14\" cy=\"14\" r=\"13\"></circle></g></svg>"


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/arrow-circle.svg
// module id = 1507
// module chunks = 0